export default __webpack_public_path__ + "static/media/sadiq.5cd296dd.png";